import { defineComponent as _defineComponent } from 'vue'
import useHttpRequest from "@/composables/use-http-request";
import { useRouter } from "vue-router/composables";
import store from "@/store";

import HomeIcon from "@/assets/icons/svg/home.icon.svg";
import FoldersIcon from "@/assets/icons/svg/folders.icon.svg";
import UsersIcon from "@/assets/icons/svg/users.icon.svg";
import BookOpenIcon from "@/assets/icons/svg/book-open.icon.svg";
import GraduationCapIcon from "@/assets/icons/svg/graduation-cap.icon.svg";
import VideoIcon from "@/assets/icons/svg/video.icon.svg";
import TelevisionIcon from "@/assets/icons/svg/television.icon.svg";
import ClockIcon from "@/assets/icons/svg/clock.icon.svg";
import SettingsIcon from "@/assets/icons/svg/settings.icon.svg";
import LogoutIcon from "@/assets/icons/svg/logout.icon.svg";
import { useConfirmPopup } from "@/composables/use-confirm-popup";


export default /*#__PURE__*/_defineComponent({
  __name: 'side-navbar-component',
  setup(__props) {

const router = useRouter();

const closeNav = () => {
  const sidenav = document.getElementById("mySidenav");
  if (sidenav) {
    sidenav.style.width = "0";
  }
};

const logOut = async () => {
  const request = await useHttpRequest<{ success: string; message: string }>({
    method: "POST",
    url: `staff/logout`,
    loadingProperty: null,
    showSuccessMessage: false,
    showFullScreenLoader: true,
    fullScreenLoaderMessage: "Logging you out...",
  });
  if (!request) return;
  if (request.success && request.message == "LOGOUT_SUCCESSFUL") {
    store.commit("LOGOUT_USER");
    router.replace({ path: "/login" });
  }
};

const onLogoutIntent = async () => {
  closeNav();
  const confirmed = await useConfirmPopup({
    title: "Confirm Log out",
    message: "You will be immediately logged out of your account, Continue?",
    type: "DANGER",
    buttonText: " Logout",
  });

  if (!confirmed) return;

  logOut();
};

return { __sfc: true,router, closeNav, logOut, onLogoutIntent, HomeIcon, FoldersIcon, UsersIcon, BookOpenIcon, GraduationCapIcon, VideoIcon, TelevisionIcon, ClockIcon, SettingsIcon, LogoutIcon }
}

})